import React from 'react';
import { css } from '@compiled/react';

import { QuickFeedbackForArticle } from 'src/pages/ArticlePage/children/QuickFeedbackForArticle';

interface QuickFeedbackForArticleWrapperProps {
  isNextItemAvailable: boolean;
}

export const QuickFeedbackForArticleWrapper: React.FC<QuickFeedbackForArticleWrapperProps> = () => (
  <div css={quickFeedbackForArticleContainer} data-testid="quick-feedback-section">
    <QuickFeedbackForArticle shouldShowDivider={false} />
  </div>
);

const quickFeedbackForArticleContainer = css({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'flex-start',
  maxWidth: '608px',
  width: '100%',

  // override popup position
  '& [data-testid="popup"]': {
    bottom: '28px',
  },
});
